import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstLetter'
})
export class FirstLetterPipe implements PipeTransform {
  transform(value?: string, count: number = 1): string {
    if (!value) return '';

    return value
      .trim()
      .split(/\s+/)
      .slice(0, count)
      .map(word => word.charAt(0).toUpperCase())
      .join('');
  }
}
